<template>
  <div class="body">
    <div class="huodong">
      <div class="banner">
          <div class="banner_name">
              <img src="@/assets/img/name.png" alt="">
          </div>
          <div class="small_name">叠加券可在购买套餐时与其他优惠券一起使用，套餐抵扣后最低每月0元购！活动长期有效，后续可持续参加！</div>
      </div>
      <div class="contnet">
        <div class="package">
          <div class="package_content"><span>参与冲100得240元活动，</span>分24张10元叠加券，<span>每月减免10元</span>。叠加券可与优惠券一起使用。</div>
          <van-button class="confirmChangePasswordBtn" plain hairline type="info" @click="paymentSubmit('100')">参加100得240元</van-button>
        </div>
            
        <div class="package1">
          <div class="package_content"><span>参与冲80得120元活动，</span>分6张20元叠加券，<span>每月减免20元</span>。叠加券可与优惠券一起使用。</div>
            <van-button class="confirmChangePasswordBtn" plain hairline type="info" @click="paymentSubmit('80')">参加80得120元</van-button>
        </div>
        <div class="package1">
          <div class="package_content"><span>参与冲60得120元活动，</span>分12张10元叠加券，<span>每月减免10元</span>。叠加券可与优惠券一起使用。</div>
            <van-button class="confirmChangePasswordBtn" plain hairline type="info" @click="paymentSubmit('60')">参加60得120元</van-button>
        </div>
      </div>
    </div>
    <!-- 密码框   -->
    <div
      class="van-overlay"
      style="z-index: 1999"
      v-show="showPasswordPanel"
    ></div>
    <div
      class="
        van-popup van-popup--round van-popup--center
        changePasswordPanel-balanceRecharge
      "
      style="z-index: 2000; min-height: 25%; min-width: 80%"
      v-show="showPasswordPanel"
      :style="{ top: passwordPanelTop + '%' }"
    >
      <van-icon
        name="cross"
        class="icon-cross"
        @click="cancelChangePassword()"
      />
      <!-- 密码输入框 -->
      <p>设置支付密码：</p>
      <van-password-input
        :value="password"
        :focused="passwordKeyboard"
        @focus="passwordOnfocus()"
      />

      <!-- 再次确认密码输入框 -->
      <p>再次确认密码：</p>
      <van-password-input
        :value="confirmPassword"
        :focused="confirmPasswordKeyboard"
        @focus="confirmPasswordOnfocus()"
      />
      <div class="confirmChangePassword">
        <van-button
          class="confirmChangePasswordBtn"
          plain
          hairline
          type="info"
          @click="sureToRecharge()"
          >确 定</van-button
        >
      </div>
    </div>
    <!-- 数字键盘 -->
    <van-number-keyboard
      :z-index="2015"
      :show="passwordKeyboard"
      @input="passwordOnInput"
      @delete="passwordOnDelete"
      @blur="passwordKeyboard = false"
    />
    <van-number-keyboard
      :z-index="2015"
      :show="confirmPasswordKeyboard"
      @input="confirmPasswordOnInput"
      @delete="confirmPasswordOnDelete"
      @blur="confirmPasswordKeyboard = false"
    />

     <div v-html="payUrl"></div>
            <div class="shareit" v-if="is_WeChat">
              <img class="arrow" src="@/assets/img/arrowhead.png"/>
              <div class="follow">支付宝支付请使用游览器进行支付,<br />请在菜单中选择游览器打开<br />如已完成支付，退出重新登录查询即可</div>
          </div>

  </div>
</template>
<script>
import { Dialog, Toast } from "vant";
import { wxRequest } from "@/api/user.js";
export default {
  data() {
    return {
       is_WeChat:false,
      payUrl:'',


      payCode: localStorage.getItem("payCode"),
      confirmPassword: "",
      leshuaPay: localStorage.getItem("leshuaPay"),
      type: "",
      showPasswordPanel: false,
      password: "",
      payPrice: 0,
      amount: 0,
      passwordKeyboard: false,
      confirmPasswordKeyboard: false,
      passwordPanelTop: 50,
      alreadySetUp: false,
      isWx: false,
    };
  },
  created() {
      this.is_WeChat = false
    if(this.$route.query.row){
      this.payUrl = JSON.parse(decodeURIComponent(this.$route.query.row))
      this.$nextTick(()=>{
        document.forms[0].submit()
      })
    }

    //判断是不是在微信环境中
    var ua = window.navigator.userAgent.toLowerCase();
    //通过正则表达式匹配ua中是否含有MicroMessenger字符串
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      this.isWx = true;
    }
  },
  methods: {
    //立即支付
    paymentSubmit(num) {
      this.amount = num * 1 * 100
      this.sureToRecharge();
    },
    async sureToRecharge() {
      var postUrl = "order/user/create/priceOrders";
      let postPayType = 20;
      await wxRequest( "sim/get/pay/state",{iccid: localStorage.getItem("iccid")}, "post").then((res) => {
        if (res.data.code != 400) {
          //查询是什么支付类型
          if (this.payCode == 200) {
            postUrl = "order/lsPkgOrder/add/prices";
            postPayType = 50;
          } else if (res.data.code == 502) {
            postUrl = "order/hfPkgOrder/add/prices";
            postPayType = 60;
          }else if (res.data.code == 508) {
            postUrl = "order/dhPkgOrder/add/prices";
            postPayType = 80;
          }else if (res.data.code == 503) {
             postUrl = "order/jdPkgOrder/add/prices";
            postPayType = 30;
          }else if (res.data.code == 588) {
            postUrl = "order/ali/user/create/priceOrders";
            postPayType = 88;
          }else if (res.data.code == 566) {
            postUrl = "order/ebPkgOrder/add/prices";
            postPayType = 66;
          }else if (res.data.code == 507) {
            postUrl = "order/yyPkgOrder/add/prices";
            postPayType = 62;
          }
        }
      });
      var params = {
        iccid: this.$store.state.iccid ? this.$store.state.iccid : localStorage.getItem("iccid"),
        amount: this.amount, //固定值
        giftBalance: 0, //固定值
        yucun: 1, //固定值
        payType: postPayType, //
      };
      await wxRequest(postUrl, params, "post").then((res) => {
        if (res.data.code == 200) {
          if (params.payType == 50) {
            //乐刷
            window.location.href = res.data.data.jspay_url;
          } else if (params.payType == 20) {
            //微信第三方
            var param = res.data.data.param;
            if (typeof WeixinJSBridge == "undefined") {
              if (document.addEventListener) {
                document.addEventListener( "WeixinJSBridgeReady", this.onBridgeReady,  false );
              } else if (document.attachEvent) {
                document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
                document.attachEvent( "onWeixinJSBridgeReady", this.onBridgeReady  );
              }
            } else {
              this.onBridgeReady(param);
            }
          }else if (params.payType == 80||params.payType == 66) {//微信第三方
            var param = res.data.data;
              if (typeof WeixinJSBridge == "undefined") {
                if (document.addEventListener) {
                  document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
                } else if (document.attachEvent) {
                  document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
                  document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
                }
              } else {
                this.onBridgeReady(param);
              }
          }  else if (params.payType == 60) {
            //汇付天下
            let datas = JSON.parse(res.data.data);
            if (datas.status === "succeeded") {
              let payment = datas;
              AdaPay.doPay(payment, (res) => {
                Dialog.alert({ title: "提示", message: res.result_message });
              });
            }
          }else if(params.payType==88){
            var ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                //进入引导页
                this.is_WeChat = true
                var timer = setInterval(()=>{
                  clearInterval(timer)
                  this.$router.push({path: '/user/huodong2', query: {row: encodeURIComponent(JSON.stringify(res.data.data))}});
                },1000)
            } else {
              this.payUrl = res.data.data
              this.$nextTick(()=>{
                document.forms[0].submit()
              })
            }
          }else if (params.payType == 30||params.payType == 62) {
              window.location.href=res.data.data;
          }
        } else {
          Dialog.alert({ message: res.data.message });
        }
      });
    },
    onBridgeReady(param) {
      let _this = this;
      WeixinJSBridge.invoke("getBrandWCPayRequest", param, function (res) {
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          if(_this.$store.state.isNewPage==1||localStorage.getItem('isNewPage')==1){
             _this.$router
            .push({
              path: "/userNew/home",
              query: {
                iccid: _this.$store.state.iccid,
              },
            })
            .catch(() => {});
          }else{
            _this.$router
            .push({
              path: "/user/home",
              query: {
                iccid: _this.$store.state.iccid,
              },
            })
            .catch(() => {});
          }
          
        }
      });
    },
    /***   修改密码     ***/
    passwordOnfocus() {
      this.passwordKeyboard = true;
      this.confirmPasswordKeyboard = false;
      this.passwordPanelTop = 30;
    },
    passwordOnDelete() {
      this.password = this.password.slice(0, this.password.length - 1);
    },
    passwordOnInput(key) {
      this.password = (this.password + key).slice(0, 6);
    },
    confirmPasswordOnfocus() {
      this.passwordKeyboard = false;
      this.confirmPasswordKeyboard = true;
      this.passwordPanelTop = 30;
    },
    confirmPasswordOnDelete() {
      this.confirmPassword = this.confirmPassword.slice(
        0,
        this.confirmPassword.length - 1
      );
    },
    confirmPasswordOnInput(key) {
      this.confirmPassword = (this.confirmPassword + key).slice(0, 6);
    },
    cancelChangePassword() {
      this.password = "";
      this.confirmPassword = "";
      this.passwordPanelTop = 50;
      this.showPasswordPanel = false;
    },
    checkPassword() {
      if (this.alreadySetUp) {
        return true;
      }
      if (this.password.length < 6) {
        Toast.fail("请设置六位支付密码");
        return false;
      }

      if (this.password != this.confirmPassword) {
        Toast.fail("两次输入的密码不一致");
        return false;
      }
      return true;
    },
    /***   修改密码  end   ***/
  },
};
</script>
<style lang="less" scoped>
.banner{
    background: url('../../assets/img/bg.png')no-repeat center;
    background-size: 100% 100%;
    height:312px;
    text-align: center;
    .banner_name{
        padding-top:70px;
    }
    .small_name{
        margin-top:17px;
        color:#fff;
        font-size:15px;
        padding:0 13px;
        line-height: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
    }
}
.contnet{
  border-radius:30px;
  background:#fff;
  margin-top:-110px;
  padding-top:19px;
}
.package,.package1{
    margin:0 auto;
    width:86%;
    padding:19px 15px 16px;
    border-radius: 16px;
    text-align: center;
    border:1px solid #F9EBCE;
    .package_name{
        color: #171717;
        font-size:22px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        margin-bottom:8px;
    }
    .package_content{
        font-size:15px;
        color: #797979;
        margin-top:8px;
        line-height: 24px;
        margin-bottom:16px;
        span{
            color: #F86321;
        }
    }
    .confirmChangePasswordBtn{
        background: #F86C2E;
        width:90%;
        margin:0 auto;
        color:#fff;
        font-size:22px;
        font-family: HarmonyOS_Sans_SC_Bold;
        font-weight:600;
        border: 1px solid #F86C2E;
        border-radius:23px;
        height:46px;
        &::after{
            border:none ;
        }
    }
}
.package1{
    margin-top:13px;
}
.changePasswordPanel-balanceRecharge {
  padding: 10px;
  .icon-cross {
    position: absolute;
    right: 10px;
    font-size: 16px;
  }
  p {
    margin: 10px 16px 0 16px;
    line-height: 30px;
  }

  .confirmChangePassword {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
    .confirmChangePasswordBtn {
      width: 80px;
      margin: 0 15px;
    }
  }
}
.body {
  width: 100%;
  // height:100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  .t-img {
    width: 100%;
    height: 310px;
    img {
      width: 100%;
      height: 100%;
      display: inline-block;
      overflow: hidden;
      position: relative;
    }
  }
  .huodong {
    z-index: 2;
    .checkbox-info {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      margin-bottom: 20px;
      span {
        font-size: 14px;
        display: inline-block;
        padding-left: 6px;
      }
      ::v-deep .van-checkbox__icon {
        .van-icon {
          font-size: 12px;
          width: 15px;
          height: 15px;
          line-height: 15px;
        }
        padding-top: 6px;
      }
    }
    .huodongBtn {
      position: relative;
      align-self: center;
      display: flex;
      justify-content: center;
      margin-bottom: 35px;
      height: 75px;
      background: url("../../assets/hd/btn.6f7529d1.png") no-repeat center;
      background-size: 100%;
      align-items: center;
    }
  }
}



.shareit {
    -webkit-user-select: none;
    position: fixed;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.8);
    text-align: center;
    top: 0;
    left: 0;
    z-index: 999;
}
.shareit img {
    max-width: 100%;
}
.arrow {
    width: 100px;
    height: 150px;
    position: absolute;
    right: 5%;
    top: 1%;
}
.follow {
    margin-right: 6px;
    margin-left: 30px;
    width: 90%;
    // height: 100rpx;
    line-height: 30px;
    // text-align: left;
    text-decoration: none;
    font-size: 18px;
    color: white;
    float: left;
    margin-top: 180px;
}
</style>